import { lazy, Suspense, useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";

const LazyFilterSidebar = lazy(() =>
  import("@/components/FilterSidebar").then((module) => ({ default: module.FilterSidebar })),
);

interface MobileFilterBarProps {
  resultCount: number;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  category: string;
  onCategoryChange: (value: string) => void;
  categories: string[];
  minRating?: number;
  onMinRatingChange?: (value: number) => void;
  city?: string;
  onCityChange?: (value: string) => void;
  locationType?: string;
  onLocationChange?: (value: string) => void;
  locationOptions?: string[];
  plzSearch?: string;
  onPlzSearchChange?: (value: string) => void;
}

export const MobileFilterBar = ({
  resultCount,
  searchTerm,
  onSearchChange,
  category,
  onCategoryChange,
  categories,
  minRating,
  onMinRatingChange,
  city,
  onCityChange,
  locationType,
  onLocationChange,
  locationOptions,
  plzSearch,
  onPlzSearchChange,
}: MobileFilterBarProps) => {
  const [showFilter, setShowFilter] = useState(false);

  return (
    <>
      <div className="lg:hidden sticky top-14 z-40 bg-background border-b px-4 py-2 flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{resultCount} Portale</span>
        <Button variant="outline" size="sm" className="gap-1.5" onClick={() => setShowFilter(!showFilter)}>
          <SlidersHorizontal className="w-4 h-4" />
          Filter
        </Button>
      </div>
      {showFilter && (
        <div className="lg:hidden px-4 py-4 border-b bg-card">
          <Suspense
            fallback={<div className="h-24 rounded-lg border border-border bg-muted/40 animate-pulse" aria-hidden="true" />}
          >
            <LazyFilterSidebar
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              category={category}
              onCategoryChange={onCategoryChange}
              categories={categories}
              minRating={minRating}
              onMinRatingChange={onMinRatingChange}
              city={city}
              onCityChange={onCityChange}
              locationType={locationType}
              onLocationChange={onLocationChange}
              locationOptions={locationOptions}
              plzSearch={plzSearch}
              onPlzSearchChange={onPlzSearchChange}
              idPrefix="mobile"
            />
          </Suspense>
        </div>
      )}
    </>
  );
};
